import { Sparkles, Upload } from 'lucide-react';

/**
 * Inline hover mini-toolbar for data table rows (§9-E).
 * Renders a <td> with [Agent] [Upload] icon-buttons.
 * Visibility is controlled by `.ggj-row-actions` opacity in index.css:
 *   — opacity: 0 normally, opacity: 1 on parent <tr> hover/focus.
 * Add `group` (Tailwind) or just let the CSS rule handle it.
 *
 * Usage: drop as the last <td> in each data-table <tr>.
 * Pair the <thead> last column with an empty <th className="w-20" />.
 */
interface RowHoverActionsProps {
  /** Called when [Agent] (Sparkles) is clicked. e.stopPropagation is called internally. */
  onAgent?: () => void;
  /** Called when [Upload] is clicked. e.stopPropagation is called internally. */
  onUpload?: () => void;
  /** Extra CSS classes on the outer <td>. */
  className?: string;
}

const iconBtn =
  'flex h-6 w-6 items-center justify-center rounded transition-colors vscode-text-tertiary hover:vscode-text-primary hover:bg-[var(--vscode-bg-hover)]';

export function RowHoverActions({ onAgent, onUpload, className }: RowHoverActionsProps) {
  return (
    <td
      className={`px-2 py-0 text-right ${className ?? ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <span className="ggj-row-actions inline-flex items-center gap-0.5">
        <button
          type="button"
          title="Ask AI agent"
          className={iconBtn}
          onClick={(e) => {
            e.stopPropagation();
            onAgent?.();
          }}
        >
          <Sparkles className="w-3.5 h-3.5" />
        </button>
        <button
          type="button"
          title="Upload file"
          className={iconBtn}
          onClick={(e) => {
            e.stopPropagation();
            onUpload?.();
          }}
        >
          <Upload className="w-3.5 h-3.5" />
        </button>
      </span>
    </td>
  );
}
